// src/utils/dbShape.js
/**
 * Нормализация ответов list-эндпоинтов. Часть use*Query-хуков
 * (tasks/employees/vacations/roleDelegations) возвращает либо массив,
 * либо постраничный конверт { items, meta }. Потребитель не должен
 * знать форму: unwrapItems приводит к массиву (стабильный EMPTY_ARRAY
 * при отсутствии данных — безопасно для useMemo по референсу).
 *
 * Не мутирует вход; возвращает либо исходный массив, либо res.items,
 * либо EMPTY_ARRAY.
 *
 * MAX_REF_LIMIT — верхняя граница для «справочных» запросов
 * (см. task.schemas.ts::ListTasksQuerySchema.max(5000)), где нужны
 * все задачи/проекты для cross-ref lookup (ModalRenderer,
 * TagResultsModal, collectTaskPayloads). Не использовать для пагинации.
 */
export const EMPTY_ARRAY = [];

export const MAX_REF_LIMIT = 5000;

export function unwrapItems(res) {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.items)) return res.items;
  return EMPTY_ARRAY;
}
